export enum DayType {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export enum WeekType {
  WEEKDAY = "weekday",
  HOLIDAY = "holiday",
}

export type MultiDateInputFieldValue = {
  dates: Date[];
  weekday: boolean;
  holiday: boolean;
};

export type MultiDateInputContainerProps = {
  className?: string;
  includeDates: Date[];
  selected: MultiDateInputFieldValue;
  onChange: (value: MultiDateInputFieldValue) => void;
  placeholder?: string;
};
